import React from "react"
import styled from "styled-components"
import { RichText } from "prismic-reactjs"
import { Link } from "gatsby"
const TextContainer = styled.div`
  * {
    font-family: ${p => p.font || "Raleway"}, sans-serif;
    color: rgba(0, 0, 0, 0.7);
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: rgba(0, 99, 123, 0.94);
  }
  p,
  li {
    font-size: ${p => p.fontSize || "14px"};
  }
  h2 {
    font-size: 1.2rem;
  }
  h5 {
    font-family: ${p => p.h5font};
    font-size: ${p => p.h5size};
    font-weight: normal;
    margin: 5px;
    color: rgba(0, 0, 0, 0.7);
  }
  h6 {
    font-family: ${p => p.h6font};
    font-size: ${p => p.h6size};
    font-weight: normal;
    margin: 5px;
    color: rgba(0, 0, 0, 0.7);
  }
`
//
//
const PrismicRichText = ({
  text,
  style,
  font,
  fontSize,
  h5font,
  h5size,
  h6font,
  h6size,
}) => {
  const myCustomLink = (type, element, content, children, index) => {
    const to = element.data.url.replace("https://", "")
    return (
      <Link key={element.data.url} to={to}>
        {content}
      </Link>
    )
  }
  return (
    <TextContainer
      style={style}
      font={font}
      fontSize={fontSize}
      {...{ h5font, h5size, h6font, h6size }}
    >
      <RichText
        // htmlSerializer={htmlSerializer}
        serializeHyperlink={myCustomLink}
        render={text}
      />
    </TextContainer>
  )
}

export default PrismicRichText
